import io from 'socket.io-client';

let socket;
// const ENDPOINT = 'http://localhost:5000/';
const ENDPOINT = 'https://doodlebackend.internalworkpla.repl.co/';

function initialiseSocket() {
  socket = io(ENDPOINT, {
    transports: ['websocket', 'polling', 'flashsocket'],
  });
}

export function addEventListener(event) {
  // console.log(event);
  if (!socket) {
    initialiseSocket();
  }
  socket.on(event.type, event.callback);
}

export function sendEvent(event) {
  socket.emit(event.type, event.data);
}

export function clientSocketId() {
  return socket.id;
}
